__turbopack_context__.v({
  "tabs": "TabsBlock-module-scss-module__cA0BtG__tabs",
  "tabs__nav": "TabsBlock-module-scss-module__cA0BtG__tabs__nav",
  "tabs__panel": "TabsBlock-module-scss-module__cA0BtG__tabs__panel",
});
